import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { UserSettingsView } from '@blockpulse3/web-client/auth';
import {
  AdminCompanies,
  AdminDashboard,
  AdminFundraising,
  AdminIndividuals,
  DocumentsView,
  UserDocumentsView,
} from '@blockpulse3/web-client/dashboard';
import { FundraisingView } from '@blockpulse3/web-client/fundraising';
import { GraphiQLView } from '@blockpulse3/web-client/graphiql';
import { ShareholdingView } from '@blockpulse3/web-client/shareholding';
import { WorkspaceSettingsView } from '@blockpulse3/web-client/workspace';

import { AdminLayout } from '../layouts';

type Props = unknown;

/**
 * AdminRoutes.
 * Renders all admin related routes.
 *
 * @returns {JSX.Element}
 */
export function AdminRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route element={<GraphiQLView />} path={routes.admin.graphql.href} />
        <Route element={<AdminFundraising />} path={routes.admin.fundraisings.href} />
        <Route element={<AdminCompanies />} path={routes.admin.companies.href} />
        <Route path={routes.admin.company.href}>
          <Route
            element={<WorkspaceSettingsView backHref={routes.admin.companies.full} />}
            path={routes.admin.company.settings.href}
          />
          <Route
            element={<DocumentsView backHref={routes.admin.companies.full} />}
            path={routes.admin.company.documents.href}
          />
          <Route
            element={<ShareholdingView backHref={routes.admin.companies.full} />}
            path={routes.admin.company.captable.href}
          />
          <Route
            element={<FundraisingView backHref={routes.admin.fundraisings.full} />}
            path={routes.admin.company.fundraising.href}
          />
        </Route>
        <Route element={<AdminIndividuals />} path={routes.admin.individuals.href} />
        <Route path={routes.admin.individual.href}>
          <Route
            element={<UserDocumentsView backHref={routes.admin.individuals.full} />}
            path={routes.admin.individual.documents.href}
          />
          <Route
            element={<UserSettingsView backHref={routes.admin.individuals.full} />}
            path={routes.admin.individual.settings.href}
          />
        </Route>
        <Route element={<Navigate replace to={routes.admin.href} />} path="*" />
      </Route>
    </Routes>
  );
}

export type AdminRoutesProps = Props;
